import React from 'react';
import { HeadingTag, Link, ModuleBase, ResponsiveImage, Stack, Text, Breadcrumbs } from '@/components';
import classNames from 'classnames';
import { HeroModuleModel } from './HeroModule';

const HeroModulePublic = (data: HeroModuleModel) => {
  const { props } = data;
  return (
    <ModuleBase
      data={data}
      noPadding
      className={classNames(props.theme === 'Dark' ? 'module-base-dark' : 'module-base-light')}
    >
      <div className="relative min-h-[288px]">
        {props.image && (
          <div className="absolute top-0 left-0 h-full w-full lg:relative">
            <ResponsiveImage
              image={props.image.desktopImage}
              widths={{ xs: 1, sm: 640, md: 768, lg: 1024, xl: 1280, xxl: 2560 }}
              heights={{ xs: 1, sm: null }}
              dataNotLazy
              preload
              className="hidden sm:block"
            />
            <ResponsiveImage
              image={props.image.mobileImage}
              widths={{ xs: 640, sm: 1 }}
              heights={{ xs: null, sm: 1 }}
              dataNotLazy
              preload
              className="sm:hidden"
            />
          </div>
        )}
        <div className="relative top-0 left-0 h-full w-full lg:absolute">
          <Stack className="container mx-auto flex h-full flex-col justify-center">
            <div className="w-full sm:w-1/2 lg:w-2/5">
              {props.title && (
                <HeadingTag
                  tag={props.isH1 ? 'h1' : 'h2'}
                  heading={props.title}
                  role="contentinfo"
                  aria-label="contentinfo"
                  className="color-from-bg justify-center lg:mt-7"
                />
              )}

              {props.description && (
                <div className="color-from-bg text-heading6 tracking-heading6 mt-5 mb-4 leading-8 font-light not-italic">
                  <Text
                    animate
                    tag="h4"
                    className="text-sm leading-[18px] font-medium xl:text-xl xl:leading-[26px]"
                    dangerouslySetInnerHTML={{ __html: props.description }}
                  />
                </div>
              )}
              {props.cta && <Link animate link={props.cta} className="btn secondary btn-from-bg" />}
            </div>
          </Stack>
        </div>
      </div>
      {props.breadcrumb && (
        <div className="container py-3">
          <Breadcrumbs data={props.breadcrumb} />
        </div>
      )}
    </ModuleBase>
  );
};

export default HeroModulePublic;
